import * as React from 'react'
import { omit, mapValues, get } from 'lodash'
import InputField from '../../common/components/input-field'
import StandardInput from '../../common/components/standard-input'
import SelectionInput from '../../common/components/selection-input'
import SuburbAutoComplete from '../../common/components/suburb-auto-complete'
import YesNoInput from '../../common/components/yes-no-input'
import DatePicker from '../../common/components/date-picker'
import Validation from '../../common/modules/validation/rules'
import AddressPicker from '../../common/components/address-picker'
import Message from '../../common/components/message'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import QuoteNumber from '../../common/components/quote-number'
import yesNoOptions from '../../common/options/yes-no-options'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withState } from '../../common/modules/state'
import { withAddressValidation } from '../../common/modules/address-validation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withConfig } from '../../common/modules/config';


export const formConfig = state => {
    const fields = state.fields;
    const productData = state.productData;
    const addressValidation = state.addressValidation;

    return {
        rules: {
            currentInsurer:[
                Validation.enforce.required("Please select your current insurer"),
            ],
            otherInsurer:[
                Validation.enforce.required("Name of your current insurer"),
            ],
            startDate:[
                Validation.enforce.required("Please tell us when your current policy expires. This cannot be more than 30 days in the future"),
                Validation.enforce.date("Please tell us when your current policy expires. This cannot be more than 30 days in the future"),
            ],
            currentExcess:[
                Validation.enforce.required("Enter excess of your current policy"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            numberOfClaims:[
                Validation.enforce.required("Please select number of claims")
            ],
            valueOfClaims:[
                Validation.enforce.required("Please enter the amount you claimed"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            propertyInsuranceDeclined:[
                Validation.enforce.required("Please answer the Duty of Disclosure question"),
            ],
            coverLimited:[
                Validation.enforce.required("Please answer the Duty of Disclosure question"),
            ],
            ownersCorporationNumber:[],
            ownersCorporationType: [
                Validation.enforce.required("Please select a value"),
            ],
            "ownersCorporationAddress.streetNumber":[
                Validation.enforce.required("Please provide the street number"),
            ],
            "ownersCorporationAddress.streetName":[
                Validation.enforce.required("Please provide the street name"),
            ],
            "ownersCorporationAddress.suburb":[
                Validation.enforce.required("Please provide the suburb"),
            ],
            "ownersCorporationAddress.postcode":[
                Validation.enforce.required("Please provide the postcode"),
            ],
            "ownersCorporationAddress.state":[
                Validation.enforce.required("Please provide the state"),
            ],
            selfManaged:[
                Validation.enforce.required("Please tell us if your property is managed by a strata company"),
            ],
            addressNotFound:[]
        },
        predicates: {
            valueOfClaims: fields.numberOfClaims != 0 && fields.numberOfClaims != undefined,
            otherInsurer: fields.currentInsurer === "OTHER",
            ownersCorporationType: get(fields, "ownersCorporationAddress.state") === "VIC",
            currentExcess: fields.currentInsurer !== "NOT_CURRENTLY_INSURED" && fields.currentInsurer !== "NOT_KNOWN",
            
        },
        options:{
            currentInsurer: productData.productOptions.INSURER,
            propertyInsuranceDeclined: yesNoOptions,
            ownersCorporationType: productData.productOptions.OWNERS_CORP_TYPE,
            coverLimited: yesNoOptions,
            selfManaged: yesNoOptions,
            numberOfClaims:[
                { label: "0", value:0 },
                { label: "1", value:1 },
                { label: "2", value:2 },
                { label: "3", value:3 },
                { label: "4", value:4 },
                { label: "5+", value:5 },
            ]
        },
        inferred:{},
        transformOut: data => ({
            ...data,
            addressNotFound: addressValidation.addressNotFound
        })
    }
}


@withSubmission
@withNavigation
@withProductData
@withValidation
@withFields
@withAddressValidation
@withRouteBlocker
@withScrollToTop
@withConfig
@withForm(formConfig)
export default class extends React.Component<any, any> {

    render() {
        return (
            <div className="row">
                <StepTitle>Tell Us About Your Current Insurance</StepTitle>	
                <QuoteNumber />

                <InputField   field="currentInsurer"     type="String"     label="Who are you currently insured with?"         />
                <InputField   field="otherInsurer"       type="String"     label="Name of your current insurer"                />
                <InputField   field="startDate"          type="Date"       label="When do you want cover to commence?"         endDate='+90d'  help="This will be used as the start date of your new policy."/>
                <InputField   field="currentExcess"      type="Currency"   label="What is the excess on your current policy?"  />


                <SubHeader>Your Duty of Disclosure</SubHeader>
                <InputField   field="numberOfClaims"               type="Number"     label="How many claims have you had in the past three (3) years?"                        inline={ true } />   
                <InputField   field="valueOfClaims"                type="Currency"   label="Value of claims"                                                                  inline={ true } />
                <InputField   field="propertyInsuranceDeclined"    type="Boolean"    label="Has insurance on this property been declined in the past three (3) years?"        />                              
                <InputField   field="coverLimited"                 type="Boolean"    label="Has the cover under your current policy been limited or restricted in any way?"   />

                

                <SubHeader>Tell Us About Your Owners Corporation</SubHeader>
                <InputField    field="ownersCorporationNumber"                  type="String"     label="Owners Corporation Number"               inline={ true }   help={<span><p>Please do not input prefixes before the plan number - e.g. for 'SP12345' enter '12345 'and for 'PS654321G' enter '654321G'.</p><p>We cannot provide you a quote without a valid Owners Corporation number. A sales representative will be in touch to confirm the correct Owners Corporation number within the next business day once you complete this quote.</p></span>}/>
                

                <SubHeader>Owners Corporation address</SubHeader>
                <InputField   field="ownersCorporationAddress.streetNumber"    type="String"     label="Street Number"           size="col-sm-3"  />
                <InputField   field="ownersCorporationAddress.streetName"      type="String"     label="Street Name"             size="col-sm-9"  />
                
                <InputField   field="ownersCorporationAddress.suburb"          type="SuburbAuto" label="Suburb/Town"             size="col-sm-6"  stateField="ownersCorporationAddress.state"   postcodeField="ownersCorporationAddress.postcode"/>
                <InputField   field="ownersCorporationAddress.state"           type="String"     label="State"                   size="col-sm-3"  enabled={ false } />
                <InputField   field="ownersCorporationAddress.postcode"        type="String"     label="Postcode"                size="col-sm-3"  enabled={ false } />                  
                
                <InputField    field="selfManaged"                              type="String"     label="Is the property managed by a strata company?"       reverse={ true } />
                <InputField    field="ownersCorporationType"                    type="String"     label="What is your Owners Corporation type?"   inline={true}  />       
                       
                <Button.Container>
                    <Button.Back route="/step-1" /> <Button.Continue onClick={ this.validate.bind(this)} />
                </Button.Container>

            </div>

        )
    }


    validate(){
        console.log(this.props)
        this.props.actions.validation.validate( this.validateAddress.bind(this) );
    }


    validateAddress(){
        this.props.actions.addressValidation.validateAddress( this.proceed.bind(this), null, "ownersCorporationAddress.streetNumber", "ownersCorporationAddress.streetName", "ownersCorporationAddress.suburb", "ownersCorporationAddress.state", "ownersCorporationAddress.postcode" );
    }


    proceed(){
        const config = this.props.config;

        window["dataLayer"].push({
            'event' : 'gaEvent' ,
            'eventCategory' : 'quote forms' ,
            'eventAction' : config.project + ' quote created' , // Type of quote created
            'eventLabel' : this.props.fields.quoteNumber , // Quote number created
            'eventValue' : null ,
            'eventNonInteraction' : true
    });

       this.props.actions.navigation.changeRoute("/step-3")
    }


}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-2.tsx